import { useEffect, useState } from "react";
import { Modal, Button } from "@components";
import { useUsers } from "@api";
import { useUser } from "@auth";
import SearchSelect from "./SearchSelect";

const AssignQueryModal = ({ isOpen, onClose, onAssign, submitting, currentAssigneeId, currentAssigneeName }) => {
  const { user } = useUser();
  const { data: users } = useUsers();
  const [assignee, setAssignee] = useState(null);

  // Default to the current assignee if there is one, otherwise to yourself.
  useEffect(() => {
    if (!isOpen) return;
    const list = users ?? [];
    if (currentAssigneeId) {
      setAssignee(list.find((u) => u.id === currentAssigneeId) ?? { id: currentAssigneeId, name: currentAssigneeName });
    } else {
      const me = list.find((u) => u.id === user?.guid);
      setAssignee(me ?? (user ? { id: user.guid, name: user.name, email: user.email } : null));
    }
  }, [isOpen, users, user, currentAssigneeId, currentAssigneeName]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Assign query">
      <div className="flex flex-col gap-5 p-5 sm:p-6 bg-white">
        <SearchSelect
          label="Assign to"
          placeholder="Search team…"
          value={assignee}
          onSelect={setAssignee}
          displayValue={(u) => u.name}
          getKey={(u) => u.id}
          sortBy={(u) => u.name ?? ""}
          renderOption={(u) => (
            <>
              <span className="text-sm text-zinc-900">{u.name}</span>
              {u.email && <span className="text-xs text-zinc-500">{u.email}</span>}
            </>
          )}
          options={users ?? []}
          filterOption={(u, term) => (u.name ?? "").toLowerCase().includes(term.toLowerCase())}
          emptyText="No users found"
        />

        <div className="flex flex-col-reverse sm:flex-row gap-3 pt-1">
          <Button color="secondary" className="sm:flex-1" onClick={onClose}>
            Cancel
          </Button>
          <Button
            color="primary"
            className="sm:flex-1"
            disabled={!assignee || submitting}
            submitting={submitting}
            onClick={() => onAssign(assignee)}
          >
            Assign
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AssignQueryModal;
